export const BUTTON_SIZE = {
    SMALL: 'SMALL',
    MEDIUM: 'MEDIUM',
    LARGE: 'LARGE',
    AUTO: 'AUTO',
    FULL: 'FULL',
};
export const BUTTON_SIZE_WIDTH_MAP = {
    SMALL: '86px',
    MEDIUM: '106px',
    LARGE: '126px',
    AUTO: 'fit-content',
    FULL: '100%',
};
// #TODO
// purge the button types and unify the behavior of buttons and links via onClick handlers
export const BUTTON_TYPE = {
    BUTTON: 'button',
    LINK: 'link',
};
